export class RuleBasedOutlierDetectorRuleEditDto {
    constructor() {
        /** @type {string} */
        this.name = null;
        /** @type {number} */
        this.min_value = null;
        /** @type {number} */
        this.max_value = null;
    }

    /**
     * @typedef {Object} _RuleBasedOutlierDetectorRuleEditDtoProps
     * @property {string} name
     * @property {number} min_value
     * @property {number} max_value
     *
     * @typedef {import("./OutlierDetectorEditDto").OutlierDetectorEditDtoProps & _RuleBasedOutlierDetectorRuleEditDtoProps} RuleBasedOutlierDetectorRuleEditDtoProps
     */
    /**
     *
     * @param {RuleBasedOutlierDetectorRuleEditDtoProps} props
     * @returns {RuleBasedOutlierDetectorRuleEditDto}
     */
    setup(props) {
        this.name = props.name;
        this.min_value = props.min_value;
        this.max_value = props.max_value;

        return this;
    }
}

export default RuleBasedOutlierDetectorRuleEditDto;